import React from 'react';
import './Footer.css';

const Footer = ({ onNavigate }) => {
  const footerLinks = [
    { id: 'privacy', label: 'Privacy Policy' },
    { id: 'cookies', label: 'Cookie Policy' },
    { id: 'terms', label: 'Terms of Use' },
    { id: 'faqs', label: 'FAQs' },
    { id: 'learn-basics', label: 'Learn Basics of Research' },
    { id: 'contact', label: 'Contact Us' }
  ];

  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="footer-links">
          {footerLinks.map((link, index) => (
            <React.Fragment key={link.id}>
              <button 
                className="footer-link"
                onClick={() => onNavigate(link.id)}
              >
                {link.label}
              </button>
              {index < footerLinks.length - 1 && <span className="footer-divider">|</span>}
            </React.Fragment>
          ))}
        </div>
        <div className="footer-copyright">
          © {new Date().getFullYear()} Research Methodology Wizard. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
